import { Component } from '@angular/core';
import { Events,NavController,ToastController,LoadingController, NavParams, AlertController,ModalController } from 'ionic-angular';
import { Params } from '../params';
import * as firebase from 'firebase/app';
import * as moment from 'moment';
import '../../../node_modules/moment/locale/es';

import { FindRecipePage } from './findrecipe';
import { CountersPage } from './counters';
import { ManualTagsPage } from './manualtag/manualtag';


import {CsvService} from "angular2-json2csv";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import {BeetrackProvider} from "../../providers/beetrack/beetrack";
import { Http } from '@angular/http';


@Component({template: `
  <ion-tabs class="tabs-icon" [color]="'primary'">
    <ion-tab tabTitle="Menu Diario" tabIcon="paper" [root]="tab1"> </ion-tab>
    <!--<ion-tab tabTitle="Menu Semanal" tabIcon="md-calendar" [root]="tab2"></ion-tab>-->
    <ion-tab tabTitle="Etiquetas Impresas" tabIcon="pricetags" [root]="tab3"></ion-tab>
  </ion-tabs>
`})
export class MenusPage {
  tab1;
  tab2;
  tab3;
  plans;
  constructor(public events: Events) {
    this.tab1 = MenuDiarioPage;
    this.tab2 = MenuSemanalPage;
    this.tab3 = CountersPage;
  }
}

@Component({selector: 'page-menudiario', templateUrl: 'menudiario.html'})
export class MenuDiarioPage {
  dia = moment().startOf('day').format();
  foods : any;
  _foods : any;
  menu : any;
  _menu : any;
  print : boolean = true;
  recipes = [];
  _recipes;
  customers;
  orderBy : string = "foodCode";
  groupingredients = {};
  printed : boolean = false;
  max = String(moment().add(1, 'year').format("YYYY-MM-DD"));
  constructor(
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    private alertCtrl : AlertController,
    private nav: NavController,
    private _csvService: CsvService,
    private bee : BeetrackProvider,
    private http: Http)
  {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    this.foods = [];
    firebase.database().ref('/foods').orderByChild("active").equalTo(true).once('value').then((snapshot)=>{
      let ref_foods = snapshot.val();
      this._foods =ref_foods;
      for(let i=0;i<Object.keys(ref_foods).length;i++){
        let temp_plan = ref_foods[Object.keys(ref_foods)[i]];
        temp_plan.key = Object.keys(ref_foods)[i];
        this.foods.push(temp_plan);
      }
      this.changeDate();
    });
    firebase.database().ref('/groupingredients').once('value').then((snapshot)=>{
      if(snapshot.exists()) this.groupingredients = snapshot.val();
    });
    firebase.database().ref('/recipes').orderByChild("active").equalTo(true).once('value').then((snapshot)=>{
      let ref_foods = snapshot.val();
      this._recipes = ref_foods;
      for(let i=0;i<Object.keys(ref_foods).length;i++){
        let temp_recipe = ref_foods[Object.keys(ref_foods)[i]];
        temp_recipe.key = Object.keys(ref_foods)[i];
        this.recipes.push(temp_recipe);
      }
      this.recipes = this.recipes.filter((item) => {return (item.deleted==undefined || !item.deleted);});
    });

  }


  changeDate(){
    this.print = true;
    let loading = this.loadingCtrl.create({
      content: 'Buscando menú...'
    });
    loading.present();
    setTimeout(() => {
      this.dia = this.dia.substr(0,10);
      //let fecha = moment(this.dia).format("YYYYMMDD");

      let day = moment(this.dia).format("dd");
      const code = moment(this.dia).format('YYYY')+'W'+moment(this.dia).week();
      console.log(day,code);

      this.http.post('https://irp-system.web.app/weekMenuFitfood',{
        'company' : 'NeozyuxJrPPNiwkwiPfy',
        'week' : code,
        'flagSys': true
      }).subscribe((resp)=>{
        console.log('resp',resp.json())
        loading.dismiss();
        this.menu = this.filterDay(day,resp.json().data);
      })


      /* firebase.database().ref('/menues/'+fecha).once('value')
        .then((snapshot)=>{
          loading.dismiss();
          if(snapshot.exists()){
            this._menu = snapshot.val();
            this.menu = this.load_menu(snapshot.val());
            this.print = false;
          }else{
            this.menu = this.foods;
            this.clean_menu();
          }

        });
      firebase.database().ref('/charges/'+fecha).once('value')
        .then((snapshot)=>{
          this.printed = snapshot.exists();
        })

       */
    },100);
  }


  filterDay(day,data){
    data = data.map((f)=>{
      f.days = f.days.filter((d)=>d.name===day);
      return f;
    });
    console.log(data,day);
    return data;
  }

  deleteRecipe(m){
    let index = this.menu.indexOf(m);
    this.menu[index].plato = {recipes:[],name:"",duration:0};
  }

  getImageURL(p){
    if(p){
      if(p.prods.length > 0){
        return p.prods[0].imageList[0].downloadURL
      } else {
        return "/assets/img/photo.jpg";
      }
    } else {
      return "/assets/img/photo.jpg";
    }

  }

  assignRecipe(m,add){
    let index = this.menu.indexOf(m);
    let modal = this.modalCtrl.create(FindRecipePage,{recipes:this.recipes,add:add});
    modal.onDidDismiss(data => {
      if(typeof data!="undefined" && data!=null){
        console.log(data);
        if(data.first){
          this.menu[index].plato.name = data.name;
          this.menu[index].plato.duration = data.duration;
        }else{
          this.menu[index].plato.name = this.menu[index].plato.name +" " +data.conector + " " +data.name;
          if(data.duration<this.menu[index].plato.duration){
            this.menu[index].plato.duration = data.duration;
          }
        }
        this.menu[index].plato.recipes.push(data);
      }
    });
    modal.present();
  }

  beetrack(){
    let loading = this.loadingCtrl.create({
      content: 'Generando guías de despacho. Este proceso puede tardar varios minutos, se enviará una notificación al celular cuando termine.'
    });
    loading.present();

    firebase.database().ref('/charges/'+moment(this.dia).format("YYYYMMDD")+'/data').orderByChild("shipping").equalTo(true).once('value')
      .then((snap1)=>{
        let customers = (<any>Object).values(snap1.val());
        let business_customers = 0;
        if(customers[0].data.route){
          const dispatches = [];
          for(let c=0;c<customers.length;c++){
            if(customers[c].data.route.n!="E"){
              //const namekey = Params.generate_guide_code(customers[c].data.name,customers[c].data.lastname);
              const key = 'GUI-'+moment(this.dia).format("YYYYMMDD")+'-'+customers[c].data.route.n+'-'+customers[c].data.email;
              const dispatch = {
                "identifier" : key,
                "contact_name" : customers[c].data.name+" "+customers[c].data.lastname,
                "contact_address" : customers[c].data.address,
                "contact_phone" : customers[c].data.phone,
                "contact_email" : customers[c].data.email,
                "contact_id" : customers[c].data.email,
                "latitude" : customers[c].data.location ? customers[c].data.location.lat : "",
                "longitude" : customers[c].data.location ? customers[c].data.location.lng : "",
                "min_delivery_time": moment(this.dia).format("YYYY-MM-DD")+" 01:00:00-0300",
                "max_delivery_time": moment(this.dia).format("YYYY-MM-DD")+" 23:59:00-0300",
                "tags" : [ {  "name": "address_info", "value": customers[c].data.address_info}],
                "items": [],
                "priority": 1,
                "service_time" : 1,
                "load" : 1
              }

              for(let i=0;i<customers[c].foods.length;i++){
                dispatch.items.push({
                  "code" : customers[c].foods[i].food_key,
                  "quantity" : "1",
                  "description" : customers[c].foods[i].food_menu
                })
              }
              dispatches.push(dispatch)
            }else{
              business_customers++;
            }
          }
          console.log(business_customers);
          this.bee.generateRoute({
            dispatches : dispatches,
            business_customers : business_customers,
            owner : Params.USER_DATA.email,
            date_client : new Date().toISOString(),
            date: moment(this.dia).format("DD-MM-YYYY")
          }).then(()=>{
            let alert = this.alertCtrl.create({
              title: 'Proceso generado exitosamente',
              subTitle: 'Ha concluido el proceso de carga de despachos en Beetrack.',
              buttons: ['Entie']
            });
            alert.present();
            loading.dismiss();
          }).catch(()=>{
            let alert = this.alertCtrl.create({
              title: 'Problemas de conexión',
              subTitle: 'No nos pudimos conectar con Beetrack :(',
              buttons: ['Intentaré mas tarde']
            });
            alert.present();
            loading.dismiss();
          })
          console.log(dispatches);

        }else{
          let alert = this.alertCtrl.create({
            title: 'No se puede imprimir',
            subTitle: 'Debe reimprimir las etiquetas',
            buttons: ['Aceptar']
          });
          alert.present();
          loading.dismiss();
        }
      })
  }


  bagTags(){
    let loading = this.loadingCtrl.create({
      content: 'Generando etiquetas...'
    });
    loading.present();
    firebase.database().ref('/charges/'+moment(this.dia).format("YYYYMMDD")+'/data').orderByChild("shipping").equalTo(true).once('value')
      .then((snap1)=>{
        let customers = (<any>Object).values(snap1.val());
        if(customers[0].data.route){
        customers.sort((a,b) => {
          if (a["data"]["route"]["n"] > b["data"]["route"]["n"]) {
            return 1;
          } else if (a["data"]["route"]["n"] < b["data"]["route"]["n"]) {
            return -1;
          }
        });
        let dd = {
          content: [],
          pageSize: 'FITFOOD',
          pageMargins : [ 20, 10, 10, 10 ],
          styles: {
            table: {
              "fontSize": 11,
              "margin": [0, 0, 0, 0],
            }
          }
        };

          for(let c=0;c<customers.length;c++){
            console.log(customers[c].data);
            dd.content.push({text: customers[c].data.name + " " + customers[c].data.lastname, bold: true, fontSize: 11});
            dd.content.push({
              style: 'table',
              table: {
                headerRows: 0,
                widths: [110, 2, '*'],
                body: [
                  ['Dirección', ':', {text : customers[c].data.address, fontSize: 9}],
                  ['Adicional', ':',{text: customers[c].data.address_info}],
                  [{text:'Ruta: '+customers[c].data.route.n}, '', {text: "Comidas: "+customers[c].data.foods.length}]
                ]
              },
              layout: 'lightHorizontalLines'
            })
            dd.content.push({text: 'www.fitfoodchile.cl'});
            dd.content.push({text: '', margin: [0, 22, 0, 8]});
          }
          console.log(dd);
          loading.dismiss();
          pdfMake.createPdf(dd).open();
        }else{
          let alert = this.alertCtrl.create({
            title: 'No se puede imprimir',
            subTitle: 'Debe reimprimir las etiquetas',
            buttons: ['Aceptar']
          });
          alert.present();
          loading.dismiss();
        }
      })
  }

  restrictions(){
    let loading = this.loadingCtrl.create({
      content: 'Revisando restricciones...'
    });
    loading.present();


    console.log("revisando restricciones");

    let menues = (<any>Object).values(this.menu);
    let platos_activos = [];
    let ingredientes_activos = [];
    let ingredientes_names = {};
    let menu_activo = [];
    for(let m=0;m<menues.length;m++){
      if(menues[m].plato.recipes.length){
        for(let x=0;x<menues[m].plato.recipes.length;x++){
          if(menues[m].plato.recipes[x].id!=""){
            if(platos_activos.indexOf(menues[m].plato.recipes[x].id)==-1)
              platos_activos.push(menues[m].plato.recipes[x].id+"::"+menues[m].key);
          }
        }

      }
    }
    if(platos_activos.length){
       for(let p=0;p<platos_activos.length;p++){
        let plato = platos_activos[p].split("::")[0];
        let recipe = this._recipes[plato];
        if(typeof recipe !="undefined"){
          let ing = recipe.ingredients;
          if(typeof ing!="undefined"){
            for(let i=0;i<ing.length;i++){
              if(ingredientes_activos.indexOf(ing[i].key)==-1){
                ingredientes_activos.push(ing[i].key);
                ingredientes_names[ing[i].key] = ing[i].name;
              }
              menu_activo.push(platos_activos[p]+"::"+ing[i].key);
            }
          }
        }else{
          let alert = this.alertCtrl.create({
            title: 'Problema con Receta',
            subTitle: 'La receta '+plato+' se encuentra asignada al menú de hoy pero no existe. Reasignela e intente nuevamente',
            buttons: ['Aceptar']
          });
          alert.present();
          loading.dismiss();
          return;
        }
      }

      if(ingredientes_activos.length){
        firebase.database().ref('/charges/'+moment(this.dia).format("YYYYMMDD")+'/data').orderByChild("shipping").equalTo(true).once('value')
          .then((snap1)=>{
            if(snap1.exists()){
              let match = false;
              let customers = (<any>Object).values(snap1.val());
              let texts = [];
              if(customers[0].data){

                //de.content.push({text: "Listado Restricciones Alimenticias FitFood. "+this.format(this.dia), bold: true,fontSize: 14});
                //de.content.push({text: '', margin: [0, 22, 0, 8]});
                for(let c=0;c<customers.length;c++){
                  console.log("cliente",customers[c].data.name,customers[c].shipping);
                  let cname = customers[c].data.name;
                  if(typeof customers[c].data.restrictions!="undefined"){

                    let cust_match = false;
                    let rest = Object.keys(customers[c].data.restrictions);
                    for(let r=0;r<rest.length;r++){
                      let type = customers[c].data.restrictions[rest[r]]["type"];
                      if(type==1){
                        //restriccion de ingrediente
                        if(ingredientes_activos.indexOf(customers[c].data.restrictions[rest[r]].value)!=-1){
                          match = true;
                          cust_match = true;
                          for(let m=0;m<menu_activo.length;m++){
                            if(menu_activo[m].split("::")[2]==customers[c].data.restrictions[rest[r]].value){
                              if(customers[c].data.foods.indexOf(menu_activo[m].split("::")[1])!=-1){ //Si tiene la comida en su plan
                                texts.push({
                                  "Cliente" : Params.parse_xls(customers[c].data.name+" "+customers[c].data.lastname),
                                  "Coincidencia" : "Ingrediente",
                                  "Revisar" : Params.parse_xls(customers[c].data.restrictions[rest[r]].value_name),
                                  "Ingrediente" : "",
                                  "Comida" : this._foods[menu_activo[m].split("::")[1]].name,
                                  "Receta" : Params.parse_xls(this._recipes[menu_activo[m].split("::")[0]].name),
                                  "Motivo" : customers[c].data.restrictions[rest[r]].reason,
                                  "Genero" : customers[c].gender,
                                  "Plan" : customers[c].plan_name,
                                  "Ruta" : customers[c].data.route.n
                                });
                              }
                            }
                          }

                        }
                      }

                      if(type==2){
                        //restriccion de grupo de ingredientes
                        try{
                          let code = customers[c].data.restrictions[rest[r]].value;
                          if(this.groupingredients[code].ingredients){
                            for(let x=0;x<this.groupingredients[code].ingredients.length;x++){
                              let ingredient = this.groupingredients[code].ingredients[x];
                              if(ingredientes_activos.indexOf(ingredient)!=-1){
                                match = true;
                                cust_match = true;
                                for(let m=0;m<menu_activo.length;m++){
                                  if(menu_activo[m].split("::")[2]==ingredient){
                                    if(customers[c].data.foods.indexOf(menu_activo[m].split("::")[1])!=-1){ //Si tiene la comida en su plan
                                      let x = customers[c].data.restrictions;
                                      let y = rest[r];

                                      let reason = "";
                                      if(y){
                                        let z = x[y];
                                        reason = z.reason;
                                      }
                                      texts.push({
                                        "Cliente" : Params.parse_xls(customers[c].data.name+" "+customers[c].data.lastname),
                                        "Coincidencia" : "Grupo de Ingredientes",
                                        "Revisar" : Params.parse_xls(this.groupingredients[code].name),
                                        "Ingrediente" : Params.parse_xls(ingredientes_names[ingredient]),
                                        "Comida" : this._foods[menu_activo[m].split("::")[1]].name,
                                        "Receta" : Params.parse_xls(this._recipes[menu_activo[m].split("::")[0]].name),
                                        "Motivo" : reason,
                                        "Genero" : customers[c].gender,
                                        "Plan" : customers[c].plan_name,
                                        "Ruta" : customers[c].data.route.n
                                      });
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }catch(e){
                          console.log(e.message,customers[c].data)
                        }

                      }

                      if(type==3){
                        //restriccion de receta
                        let rest_foods = [];
                        for(let m=0;m<menu_activo.length;m++){
                          let food = customers[c].data.restrictions[rest[r]].value;
                          if(menu_activo[m].split("::")[0]==food){
                            if(rest_foods.indexOf(food)==-1){
                              if(customers[c].data.foods.indexOf(menu_activo[m].split("::")[1])!=-1) { //Si tiene la comida en su plan
                                match = true;
                                cust_match = true;
                                rest_foods.push(food);

                                texts.push({
                                  "Cliente" : Params.parse_xls(customers[c].data.name+" "+customers[c].data.lastname),
                                  "Coincidencia" : "Receta",
                                  "Revisar" : Params.parse_xls(customers[c].data.restrictions[rest[r]].value_name),
                                  "Ingrediente" : "",
                                  "Comida" : this._foods[menu_activo[m].split("::")[1]].name,
                                  "Receta" : Params.parse_xls(this._recipes[menu_activo[m].split("::")[0]].name),
                                  "Motivo" : customers[c].data.restrictions[rest[r]].reason,
                                  "Genero" : customers[c].gender,
                                  "Plan" : customers[c].plan_name,
                                  "Ruta" : customers[c].data.route.n
                                });
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }

              loading.dismiss();
              if(!match){
                let alert = this.alertCtrl.create({
                  title: 'No hay restricciones',
                  subTitle: 'No existen restricciones para el menú este día',
                  buttons: ['Aceptar']
                });
                alert.present();
              }else{
                //pdfMake.createPdf(de).open();
                this._csvService.download(texts, 'Restrictions_'+this.format(this.dia));
              }
            }
          });
      }else{
        let alert = this.alertCtrl.create({
          title: 'No hay ingredientes',
          subTitle: 'No se encontraron ingredientes para los platos de hoy',
          buttons: ['Aceptar']
        });
        alert.present();
        loading.dismiss();
      }


    }else{
      let alert = this.alertCtrl.create({
        title: 'No hay platos asignados',
        subTitle: 'Debe asignar platos a los menúes',
        buttons: ['Aceptar']
      });
      alert.present();
      loading.dismiss();
    }

  }

  generateCustomTags(){
    this.nav.push(ManualTagsPage,{dia : this.dia,_foods : this._foods,foods:this.foods,_menu:this._menu});
  }

  private cleanUndefined(cond){
    let r = {};
    if(cond){
      let v = Object.keys(cond);
      for(let i=0;i<v.length;i++){
        if(cond[v[i]]!=undefined && cond[v[i]]!='') r[v[i]] = cond[v[i]];
      }
    }
    return r;
  }

  generateTags(){
    let loading = this.loadingCtrl.create({
      content: 'Generando Etiquetas...'
    });
    loading.present();
    let inactive_customers = 0;
    let charges = {};
    firebase.database().ref('/customers').once('value')
      .then((snap1)=>{
        let cust = snap1.val();
        firebase.database().ref('/plans').orderByChild("active").equalTo(true).once('value')
          .then((snap2)=>{
            let plans = snap2.val();
            if(Object.keys(plans).length){
              let today = moment(this.dia).format("DD-MM-YYYY");
              let dd = {
                content: [],
                pageSize: 'FITFOOD',
                pageMargins : [ 20, 10, 10, 10 ],
                styles: {
                  table: {
                    "fontSize": 11,
                    "margin": [0, 0, 0, 0],
                  }
                }
              };
              let de = {
                content: [],
                pageSize: 'FITFOODSMALL',
                pageMargins : [ 50, 10, 100, 10 ],
                styles: {
                  table: {
                    "fontSize": 8,
                    "margin": [0, 0, 0, 0],
                  }
                }
              };
              let lt = [];
              let bt = [];
              let count = 0;
              let activos = 0;
              for(let i=0;i<Object.keys(cust).length;i++){
                let c = cust[Object.keys(cust)[i]];
                let charge = {
                  plan_name : c.plan,
                  gender : c.sexo,
                  foods : [],
                  // day_value : Params.dayPrize(c,this._foods,false),
                  shipping : false,
                  noshipping_reason : "",
                  noshipping_aditional_info : "",
                  restrictions : "",
                  data : {
                    restrictions : this.cleanUndefined(c.restrictions),
                    name : c.name,
                    lastname: c.lastname,
                    email: c.email,
                    foods : c.foods,
                    address : (c.address) ? c.address : '',
                    location : (c.location) ? c.location : null,
                    address_info : (c.address_info) ? c.address_info : '',
                    route : {
                      n : (c.route) ? c.route : '',
                      pos : (c.route_pos) ? c.route_pos : '',
                      obs : (c.route_obs) ? c.route_obs : ''
                    },
                    phone : c.phone,
                    restricted_days : (c.restricted_days) ? c.restricted_days : ''
                  },
                  discount: c.discount ? c.discount : 0,
                  delivery: c.delivery ? c.delivery : 0,
                  aditional_cost: c.aditional_cost ? c.aditional_cost : 0,
                  aditional_cost_obs: c.aditional_cost_obs ? c.aditional_cost_obs : "",
                }
                let active = c.active;
                if(!active){
                  charge.noshipping_reason = "in";
                }else{
                  if(c.datestart){
                    let start = moment(c.datestart).format('MM-DD-YYYY');
                    let check = moment(this.dia).format('MM-DD-YYYY');
                    if(!moment(check).isAfter(moment(start)) && !moment(check).isSame(moment(start))){
                      active = false;
                      charge.noshipping_reason = "fi";
                      charge.noshipping_aditional_info = c.datestart;
                    }
                  }

                  if(active){
                    // Código para restringir según día
                    c.restricted_days = (c.restricted_days) ? c.restricted_days : ["1","2","3","4","5"];
                    let d = String(moment(this.dia).day());
                    if(c.restricted_days.indexOf(d)==-1){
                      if(c.restricted_days.indexOf(moment(this.dia).day())==-1){
                        active = false;
                        charge.noshipping_reason = "rd";
                        charge.noshipping_aditional_info = "";
                      }
                    }
                  }
                }

                if(active){
                  activos++;
                  //Se va a buscar si ese cliente tiene suspensión ese día
                  firebase.database().ref('/cancellations/'+moment(this.dia).format("YYYYMMDD")+'/'+Params.md5(c.email)).once('value')
                    .then((snap3)=>{
                      count++;
                      if(!snap3.exists() || (snap3.exists() && snap3.val().status==1)) {
                        charge.shipping = true;

                        let restriction = "";
                        if (typeof c.restrictions != "undefined"){
                          Object.keys(c.restrictions).map(function(key) {
                            if(c.restrictions[key].type==3){
                              restriction+= c.restrictions[key].value + ", ";
                            }else{
                              restriction+= c.restrictions[key].value_name + ", ";
                            }
                          });
                        }
                        charge.restrictions = restriction;
                        for (let j = 0; j < c.foods.length; j++) {
                          let condition = "";
                          if (typeof c.conditions != "undefined"){
                            condition = c.conditions[c.foods[j]] ? c.conditions[c.foods[j]] : '';
                          }
                          let route = ""; if (typeof c.route != "undefined") route = c.route;
                          let venc_days = 3;
                          let cook_day = moment(this.dia).subtract(1, "days");

                          if(this._menu[c.foods[j]]) { // se condiciona porque puede haber comidas nuevas sin estar asignadas
                            charge.foods.push({
                              "food_key" : c.foods[j],
                              "food_name" : this._foods[c.foods[j]].name,
                              "food_menu" : this._menu[c.foods[j]].name,
                              "condition" : condition
                            });


                            if (typeof this._menu[c.foods[j]].duration != "undefined") {
                              if (this._menu[c.foods[j]].duration > 0) venc_days = this._menu[c.foods[j]].duration;
                            }
                            let venc = moment(cook_day).add(venc_days, 'days').format("DD-MM-YYYY");
                            if (!this._foods[c.foods[j]].tag) {
                              let recipes = "";
                              if(this._menu[c.foods[j]].recipes){
                                recipes += "[";
                                for(var i=0;i<this._menu[c.foods[j]].recipes.length;i++){
                                  recipes += this._menu[c.foods[j]].recipes[i].id;
                                  if(i!=(this._menu[c.foods[j]].recipes.length-1)) recipes +=","
                                }
                                recipes += "]";
                              }
                              bt.push({
                                name : c.name,
                                lastname : c.lastname,
                                sexo : c.sexo,
                                foodName : this._foods[c.foods[j]].name,
                                foodCode : c.foods[j],
                                menuName : this._menu[c.foods[j]].name.substr(0, 40),
                                planName : plans[c.plan].name,
                                condition : condition,
                                restriction : restriction,
                                recipes : recipes,
                                route : route,
                                date : cook_day.format("DD-MM-YYYY"),
                                expiration : venc
                              });
                            } else {
                              //Etiqueta chica
                              lt.push({
                                name: c.name + " " + c.lastname,
                                food: this._foods[c.foods[j]].name,
                                plate: this._menu[c.foods[j]].name,
                                restriction: restriction,
                                route: route,
                                condition: condition,
                                date: cook_day.format("DD-MM-YYYY")
                              })
                            }
                          }


                        }
                      }else{
                        // Día suspendido
                        charge.noshipping_reason = "su";
                        charge.noshipping_aditional_info = snap3.val();
                      }
                      charges[Params.md5(c.email)] = charge;
                      // Finaliza de recorrer clientes y genera etiquetas
                      if(count==activos){
                        if(lt.length){
                          for(let w=0;w<lt.length;w++){
                              let r = lt[w].restriction;
                              let rplus = "";
                              if(lt[w].restriction.length>32){
                                r = lt[w].restriction.substr(0,32);
                                rplus = lt[w].restriction.substr(32,lt[w].restriction.length)
                              }

                              de.content.push({
                                style: 'table',
                                table: {
                                  headerRows: 0,
                                  widths: ['200', '200'],
                                  body: [
                                    [{
                                      border: [false, false, false, false],
                                      text: lt[w].food+" ("+lt[w].date+")", bold: true, fontSize: 9
                                    }],
                                    [{
                                      border: [false, false, false, false],
                                      text: lt[w].name
                                    }],
                                    [{
                                      border: [false, false, false, false],
                                      text: 'Condición :'+ lt[w].condition
                                    }],
                                    [{
                                      border: [false, false, false, false],
                                      text: 'Restricción :'+ r,
                                      fontSize:6,
                                      color: "red"
                                    }],
                                  ]
                                }
                              })
                              if(lt[w].restriction.length>32){
                                de.content[de.content.length-1].table.body.push([{border: [false, false, false, false],text:rplus,fontSize:6,color: "red"}])
                              }
                              if(lt[w].restriction.length<32){
                                de.content[de.content.length-1].table.body.push([{border: [false, false, false, false],text:"Ruta : "+lt[w].route}])
                              }
                              de.content.push({text: '', margin: [0, 32, 0, 8]});
                          }
                        }
                        if(bt.length){
                          bt.sort((a,b) => {
                            if (a[this.orderBy] > b[this.orderBy]) {
                              return 1;
                            } else if (a[this.orderBy] < b[this.orderBy]) {
                              return -1;
                            }

                            if (a.sexo < b.sexo) {
                              return -1;
                            } else if (a.sexo > b.sexo) {
                              return 1
                            } else {
                              return 0;
                            }
                          });
                          for(let x=0;x<bt.length;x++){
                            //Etiqueta grande
                            dd.content.push({text: bt[x].name + " " + bt[x].lastname, bold: true, fontSize: 11});
                            dd.content.push({
                              style: 'table',
                              table: {
                                headerRows: 0,
                                widths: [110, 2, '*',110],
                                body: [
                                  [bt[x].foodName, ':', {text : bt[x].menuName,fontSize:9}, {
                                    text: bt[x].planName,
                                    alignment: 'right'
                                  }],
                                  ['Condición', ':',{text:" " + bt[x].condition,fontSize:9}, {text: bt[x].foodCode+ " "+bt[x].recipes, alignment: 'right', fontSize: 8}],
                                  ['Restricción', ':', {text: bt[x].restriction, color: "red",fontSize:8}, {
                                    text: "Ruta:" + bt[x].route,
                                    alignment: 'right'
                                  }]
                                ]
                              },
                              layout: 'lightHorizontalLines'
                            })
                            dd.content.push({
                              text: "Fecha elaboración: " + bt[x].date + " / Consumir antes de: " + bt[x].expiration,
                              fontSize: 11
                            });
                            dd.content.push({text: '', margin: [0, 22, 0, 8]});
                          }
                        }
                        loading.dismiss();
                        //this.bee.generateRoute(charges);
                        pdfMake.createPdf(dd).open();
                        if(lt.length) pdfMake.createPdf(de).open();
                        let send = {
                          data : charges,
                          date_client : moment().toISOString(),
                          date_server : firebase.database.ServerValue.TIMESTAMP,
                          owner : Params.md5(Params.USER_DATA.email),
                          tag_type : 'auto'
                        }
                        /* this.charge = this.db.object('charges/'+moment(this.dia).format("YYYYMMDD"));
                        this.charge.set(send); */
                      }
                    });
                }else{
                  charges[Params.md5(c.email)] = charge;
                  inactive_customers++;
                  if(Object.keys(cust).length==inactive_customers){
                    //todos los clientes quedan inactivos
                    loading.dismiss();
                    let alert = this.alertCtrl.create({
                      title: 'No hay clientes',
                      subTitle: 'No corresponde imprimir etiquetas a ningún cliente en esta fecha',
                      buttons: ['Aceptar']
                    });
                    alert.present();
                  }
                }

              }

            }else{
              let alert = this.alertCtrl.create({
                title: 'No hay planes',
                subTitle: 'Debe crear planes o activar al menos uno',
                buttons: ['Aceptar']
              });
              alert.present();
            }



          })

      });
  }

  format(date){
    return moment(date).format("DD MMMM YY");
  }

  clean_menu(){
    for(let i=0;i<this.menu.length;i++){
      this.menu[i].plato = {recipes:[],name:"",duration:0};
    }
    console.log("clean_menu",this.menu)
  }

  load_menu(menu){
    let f = Object.assign([], this.foods);
    for(let i=0;i<f.length;i++){
      if(menu[f[i].key]){
        menu[f[i].key].recipes ? f[i].plato = menu[f[i].key] : f[i].plato = {recipes:[],name:"",duration:0};
      }else{
        //let sp = this.foods.splice(i,1);
        f[i].plato = {recipes:[],name:"",duration:0};
        console.error("not found",f[i].key);
      }
    }
    console.log("load_menu",f);
    return f;
  }


  generate_menu(){
    let ret = {};
    for(let i=0;i<this.menu.length;i++){
      let temp = "";
      if(typeof this.menu[i].plato!="undefined") temp = this.menu[i].plato;
      ret[this.menu[i].key] = temp;
    }
    console.log("generate_menu",ret);
    return ret;
  }

  ok(){
    let menu = this.generate_menu();
    this._menu = menu;
    /* this.menu_db = this.db.object('menues/'+moment(this.dia).format("YYYYMMDD"));
    this.menu_db.set(menu).then(_ => {
      this.print = false;
      let toast = this.toastCtrl.create({
        message: 'Menú creado exitosamente',
        duration: 3000
      });
      toast.present();
    }); */
  }
}


@Component({selector: 'page-menusemanal', templateUrl: 'menusemanal.html'})
export class MenuSemanalPage {
  days : any;
  week : number;
  planSelected:any;
  activePlan : any;
  plans;
  selectPlan :boolean = false;
  foods;
  constructor(public events: Events,private navParams: NavParams)
  {
    firebase.database().ref('/plans').once('value').then((snapshot)=>{
      var ref_plans = snapshot.val();
      this.plans = [];
      for(var i=0;i<Object.keys(ref_plans).length;i++){
        let temp_plan = ref_plans[Object.keys(ref_plans)[i]];
        temp_plan.key = Object.keys(ref_plans)[i];
        this.plans.push(temp_plan);
      }
    });
    firebase.database().ref('/foods').once('value').then((snapshot)=>{
      this.foods = snapshot.val();
    });
    moment.locale('es');
    let now = moment();
    this.week = now.isoWeek();
    this.days = Array(7).fill(0).map((n, i) => {
      return moment(now.format()).isoWeek(this.week).startOf('week').clone().add(n + i, 'day');
    });
  }

  onPlanSelected(plan){
    this.selectPlan = true;
    this.activePlan = this.plans[this.planSelected];
    this.activePlan["foodsName"] = [];
    this.activePlan.days = [];
    let f = this.activePlan.foods;
    for(let i=0;i<f.length;i++){
      this.activePlan.foodsName.push(this.foods[f[i]].name);
    }
    for(let d=0;d<this.days.length;d++){
      firebase.database().ref('/menues/'+this.days[d].format("YYYYMMDD")).once('value').then((snapshot)=>{
        console.log(snapshot.key);
        let menu = [];
        if(snapshot.exists()){
          let platos = snapshot.val();
          for(let m=0;m<f.length;m++){
            menu.push(platos[f[m]]);
          }
        }else{
          for(let m=0;m<f.length;m++){
            menu.push({recipes:[],name:"",duration:0});
          }
        }
        this.activePlan.days.push({
          day : moment(snapshot.key).format("dd DD MMMM YY"),
          menu : menu
        })
      });
    }

    console.log("Se ha seleccionado plan",this.activePlan)
  }

}







// WEBPACK FOOTER //
// ./src/pages/menus/menus.ts